<template>
	<div>
		<searchForm ref="MyTerm" @handleSubmit="handleSubmit" @exportFile="exportFile"></searchForm>
		<Row :gutter="10" style="margin-bottom: 10px;">
			<Col span="12">
			<Card class="card">
				<template #title>{{ $t('Individual.Immediate') }}({{$refs.MyTerm.formInline.TimeBegin}}至{{$refs.MyTerm.formInline.TimeEnd}})</template>
				<Row>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.ImmediateRecharge') }}:</span><span
							class="value">{{memberStatisticsPeriod.PrepayRecharge.toFixed(2)}}</span></div>
					</Col>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.ImmediateConsume') }}:</span><span
							class="value">{{memberStatisticsPeriod.PrepayConsume.toFixed(2)}}</span></div>
					</Col>
				</Row>
				<Row>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.ImmediateRefund') }}:</span><span
							class="value">{{memberStatisticsPeriod.PrepayRefund.toFixed(2)}}</span></div>
					</Col>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.ImmediateFreeze') }}:</span><span
							class="value">{{memberStatisticsPeriod.PrepayFreeze.toFixed(2)}}</span></div>
					</Col>
				</Row>
			</Card>
			</Col>
			<Col span="12">
			<Card class="card">
				<template #title>{{ $t('Individual.Wallet') }}({{$refs.MyTerm.formInline.TimeBegin}}至{{$refs.MyTerm.formInline.TimeEnd}})</template>
				<Row>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.WalletRecharge') }}：</span><span
							class="value">{{memberStatisticsPeriod.WalletRecharge.toFixed(2)}}</span></div>
					</Col>
					<Col>
					<div><span class="text">{{ $t('Individual.WalletConsume') }}：</span><span
							class="value">{{memberStatisticsPeriod.WalletConsume.toFixed(2)}}</span></div>
					</Col>
				</Row>
				<Row>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.WalletRefund') }}：</span><span
							class="value">{{memberStatisticsPeriod.WalletRefund.toFixed(2)}}</span></div>
					</Col>
					<Col span="12">
					<div><span class="text">{{ $t('Individual.WalletFreeze') }}：</span><span
							class="value">{{memberStatisticsPeriod.WalletFreeze.toFixed(2)}}</span></div>
					</Col>
				</Row>
			</Card>
			</Col>
		</Row>
		<Table :columns="columns1" :data="data" :height="tableHeight" ref="tableData"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getTransactionRecordInfoUrl" @listData='getDeviceData'>
		</MyPage>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './TransactionRecordInfoComponent/searchForm.vue';
	import webapi from '../../../webapi.js';
	import { formatLocalTime } from "../../../utils/date"

	export default {
		components: {
			searchForm
		},
		data() {
			return {
				getTransactionRecordInfoUrl: webapi.base_api_url + '/Member/GetTransactionRecordInfo',
				memberStatisticsPeriod: {
					PrepayRecharge: 0,
					PrepayConsume: 0,
					PrepayRefund: 0,
					PrepayFreeze: 0,
					WalletRecharge: 0,
					WalletConsume: 0,
					WalletRefund: 0,
					WalletFreeze: 0,
				},
				//Query Component Parameters
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: [this.$t('memberCard') , '>>',this.$t('memberTransRecord')],
				//Table Title Data
				columns1: [{
						title:  this.$t('Individual.TransactionTime'),
						key: 'TransactionTime',
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.TransactionTime))
						}
					}, {
						title: this.$t('Individual.CardNo'),
						key: 'CardNo',
					},
					// {
					// 	title: '会员Id',
					// 	key: 'MemberId',
					// 	width: 100
					// }, 
					{
						title: this.$t('Individual.MemberName'),
						key: 'MemberName',
					},
					{
						title: this.$t('Individual.PhoneNo'),
						key: 'PhoneNo',
					},
					// {
					// 	title: '交易状态',
					// 	key: 'TransactionStatus',
					// 	width: 120
					// },
					{
						title:  this.$t('Individual.TransactionAmount'),
						key: 'TransactionAmount',
					},
					{
						title:  this.$t('Individual.TransactionBalanceBefore'),
						key: 'TransactionBalanceBefore',
					},
					{
						title: this.$t('Individual.TransactionBalanceAfter'),
						key: 'TransactionBalanceAfter',
					},
					{
						title: this.$t('Individual.TransactionType'),
						key: 'TransactionType',
						render: (h, params) => {
							// let type = '';
							// switch(params.row.TransactionType){
							// 	case 1:
							// 	type="充值"
							// 	break;
							// 	case 2:
							// 	type="退款"
							// 	break;
							// 	case 3:
							// 	type="消费"
							// 	break;
							// 	case 4:
							// 	type="赠送"
							// 	break;
							// }
							return h('div', params.row.TransactionTypeDesc);
						},
					},
					// {
					// 	title: '交易来源',
					// 	key: 'TransactionSource',
					// 	width: 200
					// },
					{
						title:  this.$t('Individual.TransactionOrderNo'),
						key: 'TransactionOrderNo',
						width: 250
					},
					// {
					// 	title: '交易内容',
					// 	key: 'TransactionContent',
					// 	width: 200
					// },
					// {
					// 	title: '商户订单号',
					// 	key: 'TransactionTradeNo',
					// 	width: 200
					// },
					// {
					// 	title: '充电记录ID',
					// 	key: 'TransactionBalanceBefore',
					// 	width: 200
					// },
					// {
					// 	title: '充电流水号',
					// 	key: 'ChargeSerialNo',
					// 	width: 200
					// },
					// {
					// 	title: '操作者',
					// 	key: 'Operator',
					// 	width: 200
					// },
				],
				data: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 360;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: this.$t('Individual.MemberTransactionRecords'),
					columns: this.columns1,
					data: this.data.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.TransactionOrderNo = "\t" + k.TransactionOrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						k.State = k.StateDesc;
						k.TransactionType = k.TransactionTypeDesc;
						return k;
					})
				})
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			/**Component Fixing Method**/
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Member/GetMemberStatisticsPeriod ", _this.$refs.MyTerm
					.formInline, {}).then(
					res => {
						if (res.data.Code == 0) {
							// _this.$Message.success('请求成功');
							_this.memberStatisticsPeriod = res.data.Data;
						} else {
							_this.$Message.error(this.$t('Common.Success'));
						}
					}).catch(err => {
					_this.$Message.error(this.$t('Common.Failed'));
				});
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 340 - (window.innerWidth < 1378 ? 40 : 0);
			},
		},
	}
</script>

<style scoped>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */
	#app {
		text-align: left;
	}

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.ivu-card-head::before {
		content: '⊱⊱ ';
		color: lightskyblue;
	}

	.ivu-card-head::after {
		content: ' ⊰⊰';
		color: lightskyblue;
	}

	.summy .text,
	.card .text {
		font-size: 16px;
	}

	.card .value {
		font-size: 18px;
		/* color: royalblue; */
	}
</style>
